import { useState, useCallback } from "react"
import PropTypes, { string } from "prop-types"
import { graphQueryBang, gql } from "shared/lib/graphql"
import UpgradeToProModal from "./upgrade_to_pro_modal"
import CheckoutModal from "./upgrade_to_pro_modal/checkout_modal"
import { data } from "browserslist"

interface Props {
  user: object
  eligibleForTrial: boolean
  proPlusProductId: string
  serviceName: string
  subscriptionPaymentType: string
  isTrialing: boolean
  urls: { [key: string]: string }
}

const GatedServiceAuthButton = ({
  user,
  eligibleForTrial,
  proPlusProductId,
  serviceName,
  subscriptionPaymentType,
  isTrialing,
  urls: { redirectToConnect, newProSubscriptionUrl, modalSubscriptionUrl },
}: Props) => {
  const [showModal, setShowModal] = useState(false)
  const [showCheckoutModal, updateCheckoutModalVisibility] = useState(false)

  const onUpgrade = () => {
    graphQueryBang(userQuery, {}).then((res: { me: { tier: string } }) => {
      if (res.me.tier !== "free") {
        connect()
      }
    })
  }

  const connect = () => (window.location = redirectToConnect)

  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  }, [showModal])

  return (
    <>
      <UpgradeToProModal
        visible={showModal}
        step="pro_service_tqas"
        tierRequirement="intermediate_pro"
        premiumService={serviceName}
        onUpgrade={onUpgrade}
        showCheckoutModal={() => updateCheckoutModalVisibility(true)}
        onClose={() => setShowModal(false)}
        eligibleForTrial={eligibleForTrial}
        currentTier={user.tier}
        subscriptionPaymentType={subscriptionPaymentType}
        proPlusProductId={proPlusProductId}
        isTrialing={isTrialing}
        trackLocationType="service"
      />
      <CheckoutModal
        visible={showCheckoutModal}
        target={"intermediate_pro"}
        onClose={() => updateCheckoutModalVisibility(false)}
        onUpgrade={onUpgrade}
        locationType="services"
        newProSubscriptionUrl={newProSubscriptionUrl}
        modalSubscriptionUrl={modalSubscriptionUrl}
      />
      <a
        href="#"
        onClick={() => setShowModal(true)}
        className="button-secondary button-on-color"
        data-turbolinks="false"
        title="Connect"
      >
        Connect
      </a>
    </>
  )
}

GatedServiceAuthButton.propTypes = {
  currentTier: PropTypes.string,
  eligibleForTrial: PropTypes.bool,
  newProPlusSubscriptionUrl: PropTypes.string.isRequired,
  proPlusProductId: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  subscriptionPaymentType: PropTypes.string,
  isTrialing: PropTypes.bool,
  urls: PropTypes.shape({
    redirectToConnect: PropTypes.string.isRequired,
    newProSubscriptionUrl: PropTypes.string.isRequired,
    newProPlusSubscriptionUrl: PropTypes.string.isRequired,
    modalSubscriptionUrl: PropTypes.string.isRequired,
  }),
}

GatedServiceAuthButton.defaultProps = {
  buttonOnColor: false,
}

const userQuery = gql`
  query {
    me {
      tier
    }
  }
`

export default GatedServiceAuthButton
